import { fontMedium } from 'pages/quotePdfTemplate/styleConstants';

export default function SectionLabel({ label, className }) {
  return (
    <h2
      className={`${className || ''}`}
      style={{ fontSize: '28px', fontWeight: fontMedium }}
    >
      {label}
    </h2>
  );
}
